export enum OrderbookIds {
  ORDERBOOK_LIST = 'order-book-list',
  ORDERBOOK_FOOTER = 'order-book-footer',
}
